export default __webpack_public_path__ + "static/media/question-mark.79551e5f.svg";